import Client from "./base/client";

export type BasketQuoteLine = {
  registration: string;
  available: boolean;
  total: number;
  registrationDetails?: {
    registration: string;
    display_price: string;
    display_vat: string;
    transfer_fee: string;
    price_inc_transfer: number;
    sourcecode: string;
  };
};

export type BasketQuote = { lines: BasketQuoteLine[]; total: number };

export type BasketOrder = {
  basketRef: string;
  orders: { registration: string; formId: string; price: number }[];
  unavailable: string[];
  total: number;
};

export class Basket {
  private client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  private resourceUrl = "/api/v2/checkout/basket";

  quote = (lines: { registration: string }[]): Promise<{ data: BasketQuote }> =>
    this.client.post(`${this.resourceUrl}/quote`, { lines });

  order = (payload: {
    buyer: Record<string, string>;
    lines: { registration: string; year?: string; vehicle_keeper?: string }[];
  }): Promise<{ data: BasketOrder }> =>
    this.client.post(`${this.resourceUrl}/order`, payload);
}
